import { Mail, Phone } from "lucide-react";

const Input = ({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  required = false,
  className = "",
  error = "", // new prop for error message
}) => {
  const renderIcon = () => {
    if (type === "email") return <Mail className="w-4 h-4 text-gray-400" />;
    if (type === "tel") return <Phone className="w-4 h-4 text-gray-400" />;
    return null;
  };

  const hasIcon = type === "email" || type === "tel";

  const handleChange = (e) => {
    if (type === "tel") {
      // Remove all non-digit characters and limit to 10 digits
      const digits = e.target.value.replace(/\D/g, "").slice(-10);
      onChange(digits);
    } else {
      onChange(e.target.value);
    }
  };

  return (
    <div className={`space-y-1 ${className}`}>
      <label className="block text-base font-semibold text-black mb-1">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="relative">
        {hasIcon && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3">
            {renderIcon()}
            <div className="h-5 w-px bg-gray-300 mx-2" />
          </div>
        )}
        {type === "tel" && (
          <span className="absolute left-11 top-1/2 -translate-y-1/2 text-sm text-gray-700 select-none">
            +91
          </span>
        )}
        <input
          type={type === "tel" ? "text" : type}
          value={value}
          onChange={handleChange}
          placeholder={type === "tel" ? "Enter 10-digit number" : placeholder}
          maxLength={type === "tel" ? 10 : undefined}
          className={`w-full border rounded-md h-[40px] text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#4B00E0] focus:border-transparent transition-all ${
            hasIcon ? (type === "tel" ? "pl-24 pr-3" : "pl-16 pr-3") : "px-3"
          } ${error ? "border-red" : "border-gray-300"}`}
        />
      </div>
      {error && <p className="text-red font-semibold text-sm mt-1">{error}</p>}
    </div>
  );
};

export default Input;
